"use client";
import { cn } from "@/lib/utils/utils";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";
import useLocalizer from "@/hooks/useLocalizer";

interface HoverButtonProps extends React.ComponentProps<typeof Button> {
  isLoading?: boolean;
  coverClassName?: string;
}

export const HoverButton: React.FC<HoverButtonProps> = ({
  isLoading,
  coverClassName,
  ...props
}) => {
  const { isRtl } = useLocalizer();
  return (
    <Button
      {...props}
      className={cn(
        "rounded-none relative hover:[&>div]:w-full z-50 transition-all duration-300 ease-in",
        props.className
      )}
      disabled={isLoading}
    >
      <div
        className={cn(
          "absolute bg-primary top-0 bottom-0 h-full -z-1 w-0 transition-all duration-300 ease-in ",
          isRtl ? "right-0" : "left-0",
          coverClassName
        )}
      />
      {isLoading ? <Spinner /> : props.children}
    </Button>
  );
};
